import * as resolvers from 'app/infrastructure/ui/renderer/resolvers';
import { ComplexValue, ValueProperty } from 'ui';

export const riskValues = (caseState, uiEngineProps) => ({
  riskArea: resolvers.getComponentValues(caseState, uiEngineProps, 'RiskArea').valueItem,
  riskWeight: resolvers.getComponentValues(caseState, uiEngineProps, 'Weight').value,
  riskAreaRest: resolvers.getComponentValues(caseState, uiEngineProps, 'RiskAreaResidual').valueItem,
  riskWeightRest: resolvers.getComponentValues(caseState, uiEngineProps, 'RiskWeightResidual').value  
});

export interface RiskValueShape {
  riskArea: ComplexValue<number>;
  riskWeight: ValueProperty;
  riskAreaRest: ComplexValue<number>;
  riskWeightRest: ValueProperty;
}
